import { z } from 'zod';
import { PinComponentSchema } from '../pin-component';
import { LayoutPartSchema } from '../pin-component/layout-part';
import { TipTapContentSchema } from '../tiptap-content.schema';
import { BaseInteractiveQuestionPinSettingsSchema, BasePinSchema, BaseTemplateLayoutSchema } from './base-pin';

export const SortingQuestionPinAnswerSchema = z.object({
  type: z.literal('TEXT'),
  text: TipTapContentSchema,
  shuffledOrder: z.string(), // Fractional index
});

export type SortingQuestionPinAnswer = z.infer<typeof SortingQuestionPinAnswerSchema>;

export const SortingQuestionPinLayoutKeySettingsSchema = z.enum(['TITLE_ONLY']);
export type SortingQuestionPinLayoutKey = z.infer<typeof SortingQuestionPinLayoutKeySettingsSchema>;

export const SortingQuestionPinLayoutPartKeySchema = LayoutPartSchema.extract(['TITLE', 'ANSWER_AREA']);

export const SortingQuestionPinLayoutTemplateSchema = BaseTemplateLayoutSchema.extend(
  z.object({
    key: SortingQuestionPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(SortingQuestionPinLayoutPartKeySchema, PinComponentSchema.optional()),
  }).shape
);
export type SortingQuestionPinLayoutTemplate = z.infer<typeof SortingQuestionPinLayoutTemplateSchema>;

export const SortingQuestionPinSettingsSchema = BaseInteractiveQuestionPinSettingsSchema.extend(
  z.object({
    layout: SortingQuestionPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(SortingQuestionPinLayoutPartKeySchema, z.string().optional()),
    answers: z.record(z.string(), SortingQuestionPinAnswerSchema),
  }).shape
);
export type SortingQuestionPinSettings = z.infer<typeof SortingQuestionPinSettingsSchema>;

export const SortingQuestionPinTypeSchema = z.literal('SORTING_QUESTION');

export const SortingQuestionPinSchema = BasePinSchema.extend(
  z.object({
    type: SortingQuestionPinTypeSchema,
    settings: SortingQuestionPinSettingsSchema,
  }).shape
);
export type SortingQuestionPin = z.infer<typeof SortingQuestionPinSchema>;

export const SortingQuestionPinTeacherSettingsSchema = z.object({
  correctOrder: z.array(z.string()), // answer id's in the correct order
});
